import type { ClassValue } from 'clsx';

import React from 'react';
import Link from 'next/link';

import useTranslation from '@/hooks/useTranslation';
import { cn } from '@/lib/utils';
import ArrowLeftIcon from '@/svgs/arrowLeft.svg';

type Props = {
  className?: ClassValue;
  title: string;
  showAllHref?: string;
  icon: React.ReactNode;
};

const Heading: React.FC<Props> = ({ className, title, icon, showAllHref }) => {
  const { t } = useTranslation('components.heading');
  return (
    <div className="flex items-center justify-between">
      <div className={cn('flex gap-1.5 items-end', className)}>
        <div className="w-[21px] h-[21px] flex items-center justify-center [&>svg]:w-full">
          {icon}
        </div>
        <p className="font-bold text-sm">{title}</p>
      </div>
      {showAllHref && (
        <Link
          href={showAllHref}
          className="text-sm font-normal flex items-center gap-1.5"
        >
          <span>{t('all')}</span>
          <div className="w-[13px] h-[13px] flex items-center justify-center">
            <ArrowLeftIcon />
          </div>
        </Link>
      )}
    </div>
  );
};

export { Heading };
